<template>
    <v-list dense class="kp-context-menu">
        <v-list-item :to="{ name: 'user-edit', params: { id: record.id } }">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-pencil ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('edit') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('delete-record', record)">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-trash ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
import { User } from '@/models/User';
import { frontendUrl } from '@/helpers/globals';
import { userIsStaff } from '@/helpers/auth';

export default {
    name: 'UserContextMenu',

    props: {
        record: {
            type: User,
            default: () => null,
        },
        hideDuplicate: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        userIsStaff,

        getUrl(preview = false) {
            return frontendUrl(`/user/${this.record.id}`, preview ? { preview: 'enable' } : null);
        },

        async copyUrl() {
            try {
                await navigator.clipboard.writeText(this.getUrl());
            } catch (error) {
                this.$toast({ message: this.$t('could_not_copy_to_clipboard'), color: 'error' });
            }
        },
    },
};
</script>
